import React from "react";
import { Linkedin } from "lucide-react";

export default function Board({ board = [] }) {
    if (!board || board.length === 0) return null;
    return (
        <section
            id="junta"
            data-testid="board-section"
            className="bg-white"
        >
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 sm:py-28">
                <div className="max-w-2xl mb-14">
                    <div className="text-xs uppercase tracking-widest text-[#082050]/70 mb-4">
                        Junta directiva
                    </div>
                    <h2 className="text-3xl sm:text-4xl font-semibold text-[#082050] tracking-tight">
                        Personas que representan al sector.
                    </h2>
                    <p className="mt-4 text-[#4A5568] text-lg">
                        Profesionales del alojamiento en Tarifa comprometidos con el
                        crecimiento y la representación de sus compañeros de sector.
                    </p>
                </div>

                <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-[#E2E4E9] border border-[#E2E4E9]">
                    {board.map((m, i) => (
                        <article
                            key={m.id || i}
                            data-testid={`board-member-${i}`}
                            className="bg-white p-8 flex flex-col hover:bg-[#F8F9FA] transition-colors"
                        >
                            <div className="text-[10px] uppercase tracking-widest text-[#082050]/60">
                                {m.role}
                            </div>
                            <h3 className="mt-3 text-xl font-semibold text-[#082050] tracking-tight leading-tight">
                                {m.name}
                            </h3>
                            {m.bio && (
                                <p className="mt-3 text-sm text-[#4A5568] leading-relaxed">
                                    {m.bio}
                                </p>
                            )}
                            <div className="mt-auto pt-6">
                                {m.linkedin ? (
                                    <a
                                        href={m.linkedin}
                                        target="_blank"
                                        rel="noreferrer"
                                        data-testid={`board-linkedin-${i}`}
                                        className="inline-flex items-center gap-2 text-xs font-medium text-[#082050] border border-[#082050] px-4 py-2 hover:bg-[#082050] hover:text-white transition-colors"
                                    >
                                        <Linkedin size={13} />
                                        LinkedIn
                                    </a>
                                ) : (
                                    <span className="inline-block text-xs text-[#718096] border border-[#E2E4E9] px-4 py-2">
                                        Perfil próximamente
                                    </span>
                                )}
                            </div>
                        </article>
                    ))}
                </div>
            </div>
        </section>
    );
}
